import { uniqBy } from 'lodash';

export const sortSerializedProducts = (direction, serializedProducts) => {
  return serializedProducts.sort(
    ({ checked: checkedA }, { checked: checkedB }) =>
      direction
        ? checkedA === checkedB
          ? 0
          : checkedA
          ? -1
          : 1
        : checkedA === checkedB
        ? 0
        : checkedA
        ? 1
        : -1
  );
};

export const searchSerializedProducts = (
  serialNumber,
  selected,
  serializedProducts
) => {
  if (!selected.find((serial) => serial.serialNumber === serialNumber)) {
    const newSerializedProducts = serializedProducts.map(
      (serializedProduct) => {
        if (serializedProduct.serialNumber == serialNumber) {
          serializedProduct.checked = true;
        }
        return serializedProduct;
      }
    );

    return newSerializedProducts;
  } else {
    return serializedProducts;
  }
};

export const handleResponse = (
  serializedProducts,
  item,
  checkObj,
  state,
  checkedInIds = null
) => {
  // Pre-selection is keyed off the item's serial_numbers rather than its
  // rentalItems association: the pick / check-in response (render_pick_list)
  // drops rentalItems from the redux item, so relying on it used to throw and
  // blank the modal on reopen (TD1-9961). serial_numbers is a plain attribute
  // that survives the merge.
  //
  // For check-in, once the item has been (partially) checked in its check-in
  // state lives on the SerializedPickListItem status (a serial keeps its
  // SerializedRentalItem after check-in), delivered by the backend as
  // checkedInIds — pre-select exactly those. Otherwise (checkout, or an item
  // not yet checked in) pre-select every serial that belongs to the item.
  const serialNumbers = item.serialNumbers || [];
  const useCheckedInIds = checkObj === 'checkIn' && item.status === 'checked_in';
  const isChecked = (serializedProduct) =>
    useCheckedInIds
      ? !!checkedInIds?.includes(serializedProduct.id)
      : serialNumbers.includes(serializedProduct.serialNumber);

  serializedProducts = serializedProducts.map((serializedProduct) => {
    serializedProduct = {
      ...serializedProduct,
      notes: state.textValues['notes'],
      checked: isChecked(serializedProduct),
    };

    serializedProduct[checkObj] = serializedProduct?.usageWithUnitDetails?.map(
      (unit) => ({
        id: unit.unitId,
        label: unit.unitName,
        value: unit.usage,
        type: unit.unitType,
      })
    );

    return serializedProduct;
  });

  const selected = serializedProducts.filter((serializedProduct) =>
    isChecked(serializedProduct)
  );

  const newSerializedProducts = uniqBy(
    [...state.serializedProducts, ...serializedProducts],
    (serializedProduct) => serializedProduct.serialNumber
  );
  let newSelected = uniqBy(
    [...state.selected, ...selected],
    (selected) => selected.serialNumber
  );

  return {
    newSerializedProducts: newSerializedProducts,
    newSelected: newSelected,
  };
};
